/**
 * @desc 根据年月和类型生成报告
 */
const URL = "/rantion-plat-data-flow";
import http, { updateResponse } from "@/http";
export function request(params: API.platDataFlow.monthlyReport.createReport.Params, options?: any) {
  return updateResponse(
    http(URL + `/monthlyReport/createReport`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
